// @flow
import { ReactSVG } from "react-svg";
import React from "react";
import call from "views/resources/illustrations/call.svg";
import styled, { type StyledComponent } from "styled-components";
import type { Theme } from "views/resources/theme";

interface Props {
	color: string;
	size: number | string;
}

const Walking = ({ color, size }: Props) => (
	<Wrapper color={color} size={String(size)}>
		<ReactSVG src={call} />
	</Wrapper>
);

type WrapperProps = {|
	color: string,
	size: string,
	children: React$Node,
|};

const Wrapper: StyledComponent<WrapperProps, Theme, *> = styled.div`
	svg {
		fill: ${(p) => p.color};
		width: ${(p) => p.size}rem;
	}
	margin: 15px 0px;
`;

export default Walking;
